<script>
import { mapState, mapActions } from "vuex";
import ClientFactory from "@/api/ClientFactory";
import moment from "moment";
const dropdownsApi = ClientFactory.get("dropdowns");
const revenuesApi = ClientFactory.get("revenues");
import Datepicker from "vuejs-datepicker";
import { vi } from "vuejs-datepicker/dist/locale";
import UploadFile from '../../../components/files/Upload.vue';
import { VueGoodTable } from "vue-good-table";

export default {
  components: {
    Datepicker,
    UploadFile,
    VueGoodTable
  },
  data: () => ({
    datepicker: {
      lang: {
        vi: vi,
      },
    },
    vr_report_name: "",
    vr_form_name: "",
    vr_circulars_number: "",
    vr_public_date: new Date(),
    vr_note: "",
    vr_budget_revenue: "",
    vr_unit: 2,
    vr_internal_revenue: "",
    vr_imx_revenue: "",
    valueMonthRevenues: new Date().getMonth() + 1,
    valueYearRevenues: new Date().getFullYear(),
    dataYearRevenues: [],
    valueTypeReport: 1,
    dataTypeReport: [
      {
        label: "Thu ngân sách",
        value: 1,
      },
      {
        label: "Chi ngân sách",
        value: 2,
      },
    ],
    dialog: {
      active: false,
      type: ""
    },
    attachments: {
      file_statistical: [],
      file_other: [],
      file_report: []
    },
    attachmentsFilesName: {
      file_statistical: [],
      file_other: [],
      file_report: []
    },
    dataBody:[{
      month: 1
    }]
  }),
  methods: {
    ...mapActions("ui", ["loading", "closeLoading", "notify"]),
    async AddRevenuesReport() {
      await this.$validator.validateAll();
      console.log(this.errors)
      if(this.errors.items.length > 0) {
        return this.notify({
          error: true,
          title:"Đã có lỗi", 
          text: this.errors.items[0].msg,
        });
      }
      /* if (!this.validator()) {
        return this.notify({
          error: true,
          title:"Đã có lỗi", 
          text: this.errors.items[0].msg,
        });
      } */

      if(this.attachments.file_report.length == 0) {
        return this.notify({
          error: true,
          text: 'Văn bản/báo cáo là bắt buộc',
        });
      }
      if(this.attachments.file_statistical.length == 0) {
        return this.notify({
          error: true,
          text: 'Số liệu thống kê là bắt buộc',
        });
      }
      // Starting add new report
      this.loading(this.$vs);
      let body = {};
      body.report_name = this.vr_report_name;
      body.report_type = this.valueTypeReport;
      body.status = 1;
      body.year = this.valueYearRevenues;
      body.month = this.valueMonthRevenues;
      body.form_name = this.vr_form_name;
      body.circulars_number = this.vr_circulars_number;
      body.public_date = moment(this.vr_public_date).format("DD/MM/YYYY");
      body.internal_revenue = this.vr_internal_revenue;
      body.unit_internal = this.vr_unit;
      body.imx_revenue = this.vr_imx_revenue;
      body.unit_imx = this.vr_unit;
      body.budget_revenue = this.vr_budget_revenue;
      body.unit_budget = this.vr_unit;
      body.file_statistical = this.attachments.file_statistical;
      body.file_other = this.attachments.file_other;
      body.file_report = this.attachments.file_report;
      body.note = this.vr_note;

      let result = await revenuesApi.insert_revenue(body);

      if (
        typeof result.error !== "undefined" ||
        result.data.status === "failed" ||
        result.status === "failed"
      ) {
        this.closeLoading();
        return this.notify({
          error: true,
          text: result.error || result.message,
        });
      } else {
        // this.$router.back();
        this.closeLoading();
        this.cleanForm();
        return this.notify({
          text: result.data[0].error_message,
        });
      }
    },
    cleanForm() {
      this.attachments.file_statistical = [];
      this.attachments.file_report = [];
      this.attachments.file_other = [];
      this.vr_report_name = "";
      this.vr_form_name = "";
      this.vr_circulars_number = "";
      this.vr_public_date = new Date();
      this.vr_note = "";
      this.vr_budget_revenue = "";
      this.vr_unit = 2;
      this.vr_internal_revenue = "";
      this.vr_imx_revenue = "";
    },
    convertDate(d) {
      let mm = d.getMonth() + 1; // getMonth() is zero-based
      let dd = d.getDate();

      return [
        (dd > 9 ? "" : "0") + dd,
        (mm > 9 ? "" : "0") + mm,
        d.getFullYear(),
      ].join("/");
    },

    CheckRole(id) {
      return this.AppActiveUser.role.includes(id);
    },
    GoPagesError() {
      this.notify({
        error: true,
        title: "Permission",
        text: "Bạn không có quyền truy cập trang này",
      });
      this.$router
        .push({
          path: "/pages/not-authorized",
        })
        .catch(() => {});
    },
    uploadDone() {
      this.dialog.active = false;
      switch(this.dialog.type) {
        case "file_report":
          this.attachments.file_report = this.$refs.uploadDialog.fileIds
          this.attachmentsFilesName.file_report = this.$refs.uploadDialog.fileRecordsForUpload.map(item => {
            return item.file.name
          })
          console.log(this.attachmentsFilesName.file_report)
          break;
        case "file_statistical":
          this.attachments.file_statistical = this.$refs.uploadDialog.fileIds;
          this.attachmentsFilesName.file_statistical = this.$refs.uploadDialog.fileRecordsForUpload.map(item => {
            return item.file.name
          })
          break;
        case "file_other":
          this.attachments.file_other = this.$refs.uploadDialog.fileIds;
          this.attachmentsFilesName.file_other = this.$refs.uploadDialog.fileRecordsForUpload.map(item => {
            return item.file.name
          })
          break;
        default:
          break
      }
    },
    displayUploadDialog(type) {
      this.dialog.active = true;
      this.dialog.type = type;
    }
  },

  computed: {
    ...mapState("auth", ["AppActiveUser"]),
    dataMonthRevenues() {
      return [
        {
          label: "Tháng 1",
          value: 1,
        },
        {
          label: "Tháng 2",
          value: 2,
        },
        {
          label: "Tháng 3",
          value: 3,
        },
        {
          label: "Tháng 4",
          value: 4,
        },
        {
          label: "Tháng 5",
          value: 5,
        },
        {
          label: "Tháng 6",
          value: 6,
        },
        {
          label: "Tháng 7",
          value: 7,
        },
        {
          label: "Tháng 8",
          value: 8,
        },
        {
          label: "Tháng 9",
          value: 9,
        },
        {
          label: "Tháng 10",
          value: 10,
        },
        {
          label: "Tháng 11",
          value: 11,
        },
        {
          label: "Tháng 12",
          value: 12,
        },
      ]
    },
    columns() {
      return [
        {
          label: "Tên báo cáo *",
          field: "report_name",
          thClass: "text-center",
          width: "200px",
        },
        {
          label: "Tháng *",
          field: "month",
          thClass: "text-center",
          width: "110px",
        },
        {
          label: "Năm *",
          field: "year",
          thClass: "text-center",
          width: "90px",
        },
        // {
        //   label: "Thông tư *",
        //   field: "circulars_number",
        //   thClass: "text-center",
        //   tdClass: "text-center",
        //   width: "120px",
        // },
        // {
        //   label: "Biểu mẫu",
        //   field: "form_name",
        //   thClass: "text-center",
        //   tdClass: "text-center",
        //   width: "120px",
        // },
        {
          label: "Thu nội địa *",
          field: "internal_revenue",
          thClass: "text-center",
          tdClass: "text-center",
          width: "150px",
        },
        {
          label: "Thu hoạt động XNK *",
          field: "imx_revenue",
          thClass: "text-center",
          tdClass: "text-center",
          width: "155px",
        },
        {
          label: "Thu quản lý qua NS *",
          field: "budget_revenue",
          thClass: "text-center",
          tdClass: "text-center",
          width: "150px",
        }
      ]
    },
    units() {
      return [
        {
          label: "triệu đồng",
          value: 1,
        },
        {
          label: "tỷ đồng",
          value: 2,
        },
      ]
    }
  },
  async created() {
    if (this.CheckRole(27) === false) {
      this.GoPagesError();
    } else {
      this.dataYearRevenues = await dropdownsApi.get(dropdownsApi.type.YEARS);
    }
    
  }
};
</script>

<template>
  <div id="addRevenues">
    <CCard title="Thu ngân sách" class="mb-12">
      <CCardHeader class="pt-1 pb-1">
        <span class="card-header-title">Thêm báo cáo thu ngân sách</span>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol sm="3" class="mb-2">
            <CSelect
              label="Loại báo cáo *"
              v-validate="'required'"
              name="Loại báo cáo"
              :options="dataTypeReport"
              :value.sync="valueTypeReport"
              disabled="true"
            />
          </CCol>
          <CCol sm="3" class="mb-2">
            <span>Ngày công bố *</span>
            <b-form-datepicker
              id="datepicker"
              v-model="vr_public_date"
              class="mb-2 mt-2"
              locale="vi"
              placeholder="Ngày công bố"
              :date-format-options="{
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              }"
              :hide-header="true"
              label-help=""
              :value-as-date="true"
            ></b-form-datepicker>
          </CCol>
          <CCol sm="2" class="mb-2">
            <CSelect
              label="Đơn vị"
              :options="units"
              name="Đơn vị"
              :value.sync="vr_unit"
            />
          </CCol>
        </CRow>
        <vue-good-table
                :columns="columns"
                :rows="dataBody"
                compactMode
                :pagination-options="{
                  enabled: false,
                }"
                :search-options="{
                  enabled: false,
                  placeholder: 'Tìm kiếm',
                }"
                :sort-options="{
                  enabled: false,
                }"
              >
              <template slot="table-row" slot-scope="props">
                <div v-if="props.column.field === 'report_name'">
                    <CInput
                      placeholder="Tên báo cáo thu ngân sách"
                      name="Tên báo cáo"
                      v-validate="'required'"
                      v-model="vr_report_name"
                    />
                </div>
                <div v-else-if="props.column.field === 'month'">
                    <CSelect
                      v-validate="'required'"
                      name="Tháng"
                      :options="dataMonthRevenues"
                      :value.sync="valueMonthRevenues"
                    />
                </div>
                <div v-else-if="props.column.field === 'year'">
                    <CSelect
                      v-validate="'required'"
                      :options="dataYearRevenues"
                      name="Năm"
                      :value.sync="valueYearRevenues"
                    />
                </div>
                <!-- <div v-else-if="props.column.field === 'circulars_number'">
                    <CInput
                      v-validate="'required'"
                      placeholder="VD: TT343"
                      name="Số thông tư"
                      v-model="vr_circulars_number"
                    />
                </div>
                <div v-else-if="props.column.field === 'form_name'">
                    <CInput placeholder="Số biểu mẫu" v-model="vr_form_name" />
                </div> -->
                <div v-else-if="props.column.field === 'internal_revenue'">
                    <CInput
                      name="Thu nội địa"
                      v-validate="'required|decimal'"
                      v-model="vr_internal_revenue"
                      placeholder="0"
                    />
                </div>
                <div v-else-if="props.column.field === 'imx_revenue'">
                   <CInput
                      name="Thu hoạt động XNK"
                      v-validate="'required|decimal'"
                      v-model="vr_imx_revenue"
                      placeholder="0"
                    />
                </div>
                <div v-else-if="props.column.field === 'budget_revenue'">
                    <CInput
                      name="Thu quản lý qua NS"
                      v-validate="'required|decimal'"
                      v-model="vr_budget_revenue"
                      placeholder="0"
                    />
                </div>
              </template>
        </vue-good-table>
        <CRow class="mb-2 mt-4">
          <CCol sm="3" class="ml-0">
            <span>Văn bản/báo cáo (*)</span>
            <vs-button class="ml-0" square danger @click="displayUploadDialog('file_report')"><i class="bx bx-cloud-upload"></i> &nbsp; Chọn files</vs-button>
            <span v-if="this.attachments.file_report.length > 0" style="color: #2eb85c" class="small">Đã tải lên {{this.attachments.file_report.length}} files</span>
          </CCol>
          <CCol sm="3">
            <span>Số liệu thống kê (*)</span>
            <vs-button class="ml-0" square danger @click="displayUploadDialog('file_statistical')"><i class="bx bx-cloud-upload"></i> &nbsp; Chọn files</vs-button>
            <span v-if="this.attachments.file_statistical.length > 0" style="color: #2eb85c;" class="small">Đã tải lên {{this.attachments.file_statistical.length}} files</span>
          </CCol>
          <CCol sm="3">
            <span>Tệp đính kèm khác</span>
            <vs-button class="ml-0" square danger @click="displayUploadDialog('file_other')"><i class="bx bx-cloud-upload"></i> &nbsp; Chọn files</vs-button>
            <span v-if="this.attachments.file_other.length > 0" style="color: #2eb85c;" class="small">Đã tải lên {{this.attachments.file_other.length}} files</span>
          </CCol>
        </CRow>
        <CRow class="mb-2 mt-4">
          <CCol sm="12" class="mb-2">
            <CTextarea
              multiple="true"
              label="Ghi chú"
              placeholder="Điền nội dung ghi chú cho báo cáo"
              v-model="vr_note"
            />
          </CCol>
        </CRow>
      </CCardBody>
      <CCardFooter>
        <CRow>
          <CCol sm="12" class="center">
            <vs-button square class="custom_btn_search" @click="() => {this.$router.go(-1);}"><i class="bx bx-left-arrow-alt"></i> &nbsp; Quay lại</vs-button>
            <vs-button square @click="AddRevenuesReport"><i class="bx bx-save"></i> &nbsp; Thêm báo cáo</vs-button>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>
    <vs-dialog prevent-close width="600px" scroll overflow-hidden v-model="dialog.active">
      <template #header>
        <h4 class="not-margin">
          <b>Tải lên</b>
        </h4>
      </template>
      <UploadFile ref="uploadDialog"/>
      <template #footer>
          <div class="con-footer flex flex-end">
              <vs-button square success @click="$refs.uploadDialog.uploadFiles()"><i class="bx bx-cloud-upload"></i> &nbsp; Bắt đầu tải</vs-button>
              <vs-button square danger @click="uploadDone"><i class="bx bx-save"></i> &nbsp; Xong</vs-button>
          </div>
      </template>
    </vs-dialog>
  </div>
</template>
